export default __webpack_public_path__ + "static/media/facebook.d41cf16c.svg";